import defaultTransforms from "../../transforms";
import Widget from "./Widget";

export default [Widget, ...defaultTransforms];
